module.exports = new __parcel__URL__("ITSM Runbook.2a44e062.svg").toString();